var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projectMilitaryOverview"},[_c('div',{staticClass:"projectMilitaryOverviewDiv"},[_c('p',{staticClass:"title"},[_vm._v("产品概述")]),_c('p',{staticClass:"textMsg",style:({width:this.width+'px',marginBottom:this.bottom+'px'})},[_vm._v(_vm._s(_vm.overViewText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }